import BizlyLogo from 'images/logos/bizly-dark.svg?react';
import React, { ReactNode, useContext, useState } from 'react';
import { useUserContext } from 'stores/user';
import { ThemeContext } from 'styled-components';
import { ETeams } from 'theme';
import { optimizeImageUrl } from 'utils/optimizeImageUrl';

class DefaultLogo extends React.Component<{ className?: string; children: ReactNode }> {
    state = {
        useDefault: false,
    };

    static getDerivedStateFromError() {
        return { useDefault: true };
    }

    render() {
        return (
            <div className={this.props.className}>{this.state.useDefault ? <BizlyLogo /> : this.props.children}</div>
        );
    }
}

// Component for custom logo with fallback
const CustomLogo = ({ src, isMinimized }: { src: string; isMinimized?: boolean }) => {
    const [hasError, setHasError] = useState(false);

    // If image fails to load, fall back to BizlyLogo
    if (hasError) {
        return <BizlyLogo />;
    }

    return (
        <img
            src={optimizeImageUrl(src, { trim: true })}
            alt="Logo"
            style={{
                width: '100%',
                height: '44px',
                objectFit: 'contain',
                objectPosition: isMinimized ? 'center' : 'left',
            }}
            onError={() => setHasError(true)}
        />
    );
};

const UserThemedLogo = ({ isMinimized }: { isMinimized?: boolean }) => {
    const theme = useContext(ThemeContext);
    // using theme from styled theme instead of user context respects nested overrided themes
    const usingTheme = theme?.theme !== ETeams.bizly;
    const { user } = useUserContext();

    // use brand logo from team settings
    const brandingEnabled = user?.team?.features?.enableBranding;
    const imgUrl = theme?.isThemeBright
        ? user?.team?.imageUrl || user.team?.imageUrlWhite
        : user.team?.imageUrlWhite || user.team?.imageUrl;

    // Only use custom logo if we have a valid image URL
    return (usingTheme || brandingEnabled) && imgUrl ? (
        <CustomLogo src={imgUrl} isMinimized={isMinimized} />
    ) : (
        <BizlyLogo />
    );
};

export default function ThemedLogo({ className, isMinimized }: { className?: string; isMinimized?: boolean }) {
    return (
        <DefaultLogo className={className}>
            <UserThemedLogo isMinimized={isMinimized} />
        </DefaultLogo>
    );
}
